module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/repeat-one-f0df60b741c55499ac35f4de6a0c55c7.svg";